// extracted by mini-css-extract-plugin
export default {"inputBlock":"styles_inputBlock__KyVzk","mainContainer":"styles_mainContainer__kSQ5I","flexPages":"styles_flexPages__f4J7N","clickedPage":"styles_clickedPage__Q0hhu"};